import { DOMNodeProps } from "@/types";
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { ReactNode } from "react";
import styles from "./Message.module.scss";

type MessageType = "error" | "note" | "warning" | "success";

export interface MessageProps extends DOMNodeProps {
  type: MessageType;
  title?: string;
}

export default function Message({ children, type, title, ...props }: MessageProps) {
  const icons: Record<MessageType, ReactNode> = {
    error: <ExclamationCircleOutlined />,
    note: <InfoCircleOutlined />,
    warning: <ExclamationCircleOutlined />,
    success: <CheckCircleOutlined />,
  };

  return (
    <div
      className={[styles.Message, styles[type]].join(" ")}
      {...props}
    >
      <div className={styles.icon}>{icons[type]}</div>
      <div className={styles.content}>
        {title && <span className={styles.title}>{title}</span>}
        {children}
      </div>
    </div>
  );
}
